import React from "react";
import Aboutsec from "../Menabout/Aboutsec";
// import Aboutservice from "../Menabout/Aboutservice";
// import Aboutwhyus from "../Menabout/Aboutwhyus";
// import Sliderabout from "../Menabout/Sliderabout";
// import Testimonialsabout from "../Menabout/Testimonialsabout";
// import Winningchef from "../Menabout/Winningchef";
import Bredcrumb from "../Bredcrumb/Main";
import Img from "../../assets/images/background/banner-image-1.jpg";
import usePagePhotos from "../../hooks/usePagePhotos";

function Main() {
  const { getPhoto } = usePagePhotos('about');

  // Get banner image from CMS or use hardcoded fallback
  const bannerImgPhoto = getPhoto('banner_image');
  const bannerImg = (bannerImgPhoto && bannerImgPhoto.url) ? bannerImgPhoto.url : Img;

  return (
    <>
      <Bredcrumb subtitle="About Us" title="OUR STORY" Img={bannerImg} />

      <Aboutsec />
      {/* <Winningchef />
      <Aboutservice />
      <Testimonialsabout />
      <Aboutwhyus />
      <Sliderabout /> */}
    </>
  );
}

export default Main;
